<template>
  <div class="relative min-h-screen center-blocs px-4 auth-container">
    <div class="max-w-md w-full p-8">
      <div class="center-blocs">
        <img class="h-44" src="../../assets/images/logo-sigcom.png" alt="logo-SIGCOM" />
      </div>
      <slot />
    </div>
  </div>
</template>

<style scoped>
.auth-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('@/assets/images/auth-background.jpg');
  background-size: cover;
  background-position: center;
  opacity: 0.04;
  z-index: -1;
}
</style>
